<template>
    <div id="customer_create_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">
                        <span id="customercontactHeader">Check Asset Availability</span>
                        <button type="submit" class="btn btn-success waves-effect pull-right back-btn-fl" v-on:click.prevent="backPage">
                            <i class="hi-icon icon-flback"></i>    Back
                        </button>
                    </div>
                    <div class="admin-page-content">
                        <section class="internal-container">
                            <div class="container">
                                <form class="form-horizontal basic-form-container form-custom-select" id="CustomerContactForm">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="form-group">
                                                <div class="col-sm-6">
                                                    <div class="example-label">
                                                        <label class="control-label required">From Date</label>
                                                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                                                    </div>
                                                    <date-picker placeholder="MM/DD/YYYY" id="from" name="from" :config="options" v-model="fromDate"></date-picker>
                                                    <div class="c-error">{{ fromDateError }}</div>
                                                </div>
                                                <div class="clearfix"></div>
                                                <div class="col-sm-6">
                                                    <div class="example-label">
                                                        <label class="control-label required">To Date</label>

                                                    </div>
                                                    <date-picker placeholder="MM/DD/YYYY" id="to" name="to" :config="options" v-model="toDate"></date-picker>
                                                    <div class="c-error">{{ toDateError }}</div>
                                                </div>



                                                <!-- <div class="col-sm-6">
                                                    <label class="control-label" for="locationId">Location:</label>
                                                    <v-select v-model="locationId" name="locationId" placeholder="Select Location."
                                                            label="text"
                                                            :options="locationArr">
                                                    </v-select>
                                                    <div class="c-error"></div>
                                                </div>

                                                <div class="col-sm-6">
                                                    <label class="control-label" for="assetTypeId">Asset Type:</label>
                                                    <v-select v-model="assetTypeId" name="assetTypeId" placeholder="Select Asset Type."
                                                            label="text"
                                                            :options="vehicleTypeArr">
                                                    </v-select>
                                                    <div class="c-error"></div>
                                                </div> -->
                                                <!-- <div class="form-group"> -->

                                            </div>
                                            <div class="col-sm-12 btm-action-btn-fl">
                                                <div class="row">
                                                    <button type="submit" id="submitBtn" value="Search" class="btn btn-primary nextBtn btn-lg pull-left" v-on:click.prevent="checkAvailability">
                                                        <i class="hi-icon icon-flsearch"></i> Search
                                                    </button>

                                                    <button type="submit" id="cancelBtn" value="Cancel" class="btn btn-primary nextBtn pull-left cancel-btn" v-on:click.prevent="backPage">
                                                        <i class="hi-icon icon-flCancel"></i> Cancel
                                                    </button>
                                                </div>
                                            </div>

                                        </div>

                                        <!-- </div> -->
                                    </div>
                                </form>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';


export default {
  name: "AssetAvailability",
  
  mixins:[commonMixins,contractMixins],
  data: () => ({
    options: {
        format: 'MM/DD/YYYY',
        useCurrent: true,
        minDate:new Date()
    },
    fromDate:"",
    fromDateError:"",
    assetAvailabilityVal: '',
    toDate:"",
    toDateError:"",
    locationId: null,
    locationArr: [],
    assetTypeId: null,
    loading:"",
    vehicleTypeArr:[],
    permissions: [],
    cantAccessPage: "",
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if ( permissions[i].name == 'check_asset_availability' ) {
                        self.cantAccessPage = true;
                    }
                }
            }

        },
   },
  created: function() {

  },
  mounted: function() {
        var self = this;

        //remove already set value for availability
        localStorage.removeItem("availabilityFromDate");
        localStorage.removeItem("availabilityToDate");
        localStorage.removeItem("availabilityLocation");
        localStorage.removeItem("availabilityAssetType");

        self.getPermissions();
        self.loadFieldData(['location','vehicleType']);
  },
  methods: {

    checkAvailability() {
        var error = false;
        this.fromDateError = "";
        this.toDateError = "";

        if ( this.fromDate == "" || this.toDate == "" ) {
            if ( this.fromDate == "" ) {
                this.fromDateError = "From date can not be left empty.";
            }
            if ( this.toDate == "" ) {
                this.toDateError = "To date can not be left empty.";
            }
            error = true;
        }

        if ( Date.parse(this.fromDate) > Date.parse(this.toDate)) {
            this.toDateError = "To Date should not be earlier than From Date";
            error = true;
        }

        if ( error ) {
            return;
        }

        localStorage.setItem("availabilityFromDate",this.fromDate);
        localStorage.setItem("availabilityToDate",this.toDate);
        if ( this.locationId != null ) {
            localStorage.setItem("availabilityLocation",JSON.stringify({value:this.locationId.value,text:this.locationId.text}));
        }
        if ( this.assetTypeId != null ) {
            localStorage.setItem("availabilityAssetType",JSON.stringify({value:this.assetTypeId.value,text:this.assetTypeId.text}));
        }


        this.$router.push("/asset/list");

    },
    backPage() {
      var self = this;
      self.$router.push("/asset/list");
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/asset/AssetAvailability.vue